import { gql } from 'graphql-tag'

export const fetchMonthlyThumbsUpReport = gql`
  query fetchMonthlyThumbsUpReport($stationId: ID!, $userId: ID!, $year: Int, $thumbsUpItemId: ID, $month: Int) {
    reportMonthlyThumbsUp(
      stationId: $stationId
      userId: $userId
      year: $year
      thumbsUpItemId: $thumbsUpItemId
      month: $month
    ) {
      week
      weekday
      date
      target
      actual
    }
  }
`

const ThumbsUpItemFragment = gql`
  fragment ThumbsUpItemFragment on ThumbsUpItem {
    name
    id
  }
`

export const thumbsUpItemsQuery = gql`
  query ThumbsUpItemsQuery($stationId: ID!, $year: Int, $month: Int) {
    monthlyThumbsUpItems(stationId: $stationId, year: $year, month: $month) {
      ...ThumbsUpItemFragment
    }
  }
  ${ThumbsUpItemFragment}
`

export const fetchEmployeesList = gql`
  query FetchEmployeeList($stationId: ID!) {
    employees(stationId: $stationId) {
      edges {
        node {
          id
          user {
            id
            name
          }
        }
      }
    }
  }
`
